module.exports = __webpack_public_path__ + "static/media/joey.802be4d4.jpg";